import React, { useRef, useState } from 'react';

interface FileUploadProps {
  label: string;
  accept: string;
  onFileChange: (files: File[]) => void;
  errorMessage?: string;
  multiple?: boolean;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  label,
  accept,
  onFileChange,
  errorMessage,
  multiple = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileNames, setFileNames] = useState<string[]>([]);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files ? Array.from(event.target.files) : [];
    // FIX: Explicitly type `f` as `File` to resolve a type inference issue where it was being treated as 'unknown'.
    setFileNames(files.map((f: File) => f.name));
    onFileChange(files);
  };

  const getFileNamesDisplay = () => {
    if (fileNames.length === 0) return 'No file chosen';
    if (fileNames.length === 1) return fileNames[0];
    return `${fileNames.length} files chosen`;
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-bold text-brand-grey mb-2">
        {label}
      </label>
      <div className="flex items-center space-x-2 mb-2">
        <input
          type="file"
          accept={accept}
          onChange={handleFileSelect}
          ref={fileInputRef}
          className="hidden"
          id={`file-upload-${label.replace(/\s/g, '-')}`}
          multiple={multiple}
        />
        <button
          onClick={() => fileInputRef.current?.click()}
          className="cursor-pointer bg-brand-orange text-white py-2 px-4 rounded-md hover:bg-opacity-90 transition-colors duration-200 shadow-sm"
        >
          Choose File(s)
        </button>
        <span className="text-sm text-gray-600 truncate" title={fileNames.join(', ')}>
          {getFileNamesDisplay()}
        </span>
      </div>

      {errorMessage && (
        <p className="mt-2 text-sm text-red-600">{errorMessage}</p>
      )}
    </div>
  );
};